(function () {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracCustomerReportController', NasracCustomerReportController);

    NasracCustomerReportController.$inject = ['$scope', '$state', 'NasracCustomerReport', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];


    function NasracCustomerReportController($scope, $state, NasracCustomerReport, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile) {
        var vm = this;
        vm.nasracCustomerReports = [];
        loadAll();

        var abbr = moment.tz(moment.tz.guess()).zoneAbbr();

        vm.dtInstance = {};
        var g_isArchived = false;
        vm.siteId = null;
        vm.reportsFlag = false;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                NasracCustomerReport.query(function (result) {
                    vm.nasracCustomerReports = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.nasracCustomerReports, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%'*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                //$compile(nRow)($scope);
            })

            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withDOM()
            .withOption('saveState', true)
            .withOption('order', [])
            .withDisplayLength(25)
            .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);
        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name').renderWith(function (data, type, full) {
                data = '<a ng-click="vm.get_siteId_files(\'' + data + '\', false);"> ' + data + '</a>'
                return data;

            }),
            DTColumnBuilder.newColumn('size').withTitle('Size').notVisible(),
            DTColumnBuilder.newColumn('type').withTitle('Type').notVisible(),
            DTColumnBuilder.newColumn('lastModifiedString').withTitle('Generated Date').renderWith(function (data, type, full) {
                data = data + "" + abbr;
                return data;

            })

        ];

        function loadAll() {
            NasracCustomerReport.query(function (result) {
                vm.nasracCustomerReports = result;
                vm.searchQuery = null;
            });

        }


        // Get the list of files based on the SiteId, isArchived flag
        // determines whether files need to be picked from "Archive"
        // folder or "Current" folder
        vm.get_siteId_files = function (siteId, isArchived) {

            vm.siteId = siteId;
            g_isArchived = isArchived;
            vm.reportsFlag = true;

            // Load the new data and call changeData() function for
            // reloading DataTables with new data.
            vm.dtInstance.changeData(NasracCustomerReport.query_files_by_siteId({
                siteId: siteId,
                isArchived: g_isArchived
            }).$promise);

            // Also change Columns visibility to display details.
            vm.dtColumns = [
                DTColumnBuilder.newColumn('name').withTitle('Name').renderWith(function (data, type, full) {
                    data = '<a ng-click="vm.download_report(\'' + data + '\');"> ' + data + '</a>'
                    return data;

                }),
                DTColumnBuilder.newColumn('size').withTitle('Size'),
                DTColumnBuilder.newColumn('type').withTitle('Type'),
                DTColumnBuilder.newColumn('lastModifiedString').withTitle('Generated Date').renderWith(function (data, type, full) {
                    data = data + "" + abbr;
                    return data;

                })

            ];

        }

        // This function is responsible for the file to download.
        // Makes a back-end call with file information, such that file is fetched and starts downloading.
        vm.download_report = function (reportName) {
            NasracCustomerReport.download_report({
                reportName: reportName,
                siteId: vm.siteId,
                isArchived: g_isArchived
            }).$promise
                .then(function (data) {
                    var url = URL.createObjectURL(data.response);
                    var link = document.createElement("a");
                    link.href = url;
                    link.style = "visibility:hidden";
                    link.download = reportName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
        }

        vm.reload_state = function () {
            $state.reload();
        };

    }
})();
